// Customer-facing DISPLAY titles — a pure presentation layer.
//
// The database record, seo_title, slug/canonical URL, SKU, price and feed
// data are NEVER modified by this module (owner rule: source titles are
// preserved; the 452-row backfill is cancelled). Display titles only clean
// residual feed-formatting artifacts at render time:
//   - glued words/digits      "and1/20 ctw"   -> "and 1/20 ctw"
//   - trailing measure suffix "- 18in"        -> ', 18"'
//   - stray separators / double spaces
// Fractions are KEPT as fractions (1/15 ct stays 1/15 ct) — no rounding that
// could change an apparent specification.

// Insert a space where a lowercase letter is glued to a digit ("and1/20",
// "Chain18 inch") or a digit is glued to an uppercase word ("7mmLobster").
const UNGLUE_RE = [
  [/([a-z])(?=\d)/g, "$1 "],
  [/(\d)(?=[A-Z][a-z])/g, "$1 "],
];

export const displayTitle = (p) => {
  let t = (p?.seo_title || p?.name || "").trim();
  if (!t) return t;
  for (const [re, rep] of UNGLUE_RE) t = t.replace(re, rep);
  // Trailing measurement suffix: "… Chain - 18in" -> "… Chain, 18\"".
  t = t.replace(/\s*-\s*(\d+(?:\.\d+)?)\s*in\b\s*$/i, ', $1"');
  // Any remaining " - Size 7" style suffix becomes ", Size 7".
  t = t.replace(/\s+-\s+(?=(Size\s)?\d)/, ", ");
  t = t.replace(/\s{2,}/g, " ").replace(/\s+([,.])/g, "$1").trim();
  // Drop dangling separators at the very end.
  t = t.replace(/[-–—,;.\s]+$/, "");
  // Grouped size variants: the listing represents the whole size family, so
  // the card/page title names the parent piece — size is chosen on the page.
  if (p?.variant_axis === "size") {
    t = t.replace(/\s*,?\s*Size\s+\d+(?:\.\d+)?\s*$/i, "").trim();
    t = t.replace(/[-–—,;.\s]+$/, "");
  }
  return t;
};

// N3: true when a product's primary image IS the letter-tier montage —
// query strings and case differ between feed fields, so compare bare paths.
export const isMontagePrimary = (p) => {
  if (!p?.np_hero_image || !p?.np_montage_image || !p?.image_url) return false;
  const bare = (u) => (u || "").split("?")[0].toLowerCase();
  return bare(p.image_url) === bare(p.np_montage_image);
};
